import { Flex } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, Toast } from '@common-web/index.js';
import { MdBookmark } from '@common-web/icon/icons';
import { sortQuickLinkApi } from '@apis/seller-center/quick-links.js';
import { getErrorString } from '@utils/utils.js';
import { setQuickLinks } from '@reducers/quick-links-slice/index.js';
import ManageModalBody from './manage-modal-body';
import QuickLinkChips from './quick-link-chips';

const QuickLink = () => {
  const [manageModal, setManageModal] = useState(false);
  const { quickLinks } = useSelector((state) => state?.quickLinksData);
  const [links, setLinks] = useState(quickLinks);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (quickLinks.length === 0) {
      setManageModal(false);
    }
    setLinks(quickLinks);
  }, [quickLinks, manageModal]);

  const handleSort = async () => {
    try {
      if (links.length) {
        setLoading(true);
        await sortQuickLinkApi({ quick_link_ids: links.map((link) => link.id) });
        dispatch(setQuickLinks(links));
        setManageModal(false);
      }
    } catch (err) {
      Toast.error(getErrorString(err));
    } finally {
      setLoading(false);
      return {};
    }
  };

  return (
    <div>
      <Flex align="center" justify="space-between">
        <Flex gap={12} align="center" className="flexGrow">
          <Flex gap={4}>
            <MdBookmark size="1.4em" color="var(--gray-300)" />
            <span
              style={{
                color: 'var(--gray-500)',
                fontSize: 'var(--ant-font-size-sm)',
              }}
            >
              Saved Searches:
            </span>
          </Flex>
          <QuickLinkChips quickLinks={quickLinks} />
        </Flex>

        {quickLinks.length > 0 && <Button text={'Manage'} onClick={() => setManageModal(true)} size="small" />}
      </Flex>

      <Modal
        title={'Manage Saved Searches'}
        open={manageModal}
        okButtonProps={{ loading }}
        okText="Save"
        ModalBody={<ManageModalBody links={links} setLinks={setLinks} quickLinks={quickLinks} />}
        handleOk={handleSort}
        handleCancel={() => {
          setManageModal(false);
        }}
        width={525}
        destroyOnClose={true}
        showActions={true}
      />
    </div>
  );
};

export default QuickLink;
